import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams } from 'react-router-dom';
import { EntityList, PageHead } from '../../components/EntityList';
import { useEditorReturn } from '../../hooks/useEditorReturn';
import CreditEditor from './CreditEditor';

function EditCredit() {
	const { id } = useParams();
	const navigate = useNavigate();
	const { returnTo } = useEditorReturn();

	return (
		<EntityList>
			<Helmet>
				<title>Editar Pasividad</title>
			</Helmet>
			<PageHead
				breadcrumb={[
					{ label: 'Inicio', to: '/AdminScreen' },
					{ label: 'Pasividades', to: '/AdminScreen/credits' },
					{ label: 'Editar pasividad' },
				]}
				title='Editar pasividad'
				subtitle='Actualizá los datos principales de la pasividad.'
			/>
			<CreditEditor
				mode='edit'
				creditId={id}
				onCancel={() => navigate(returnTo || `/AdminScreen/credits/credit/${id}`)}
				onSaved={(savedCreditId) => navigate(returnTo || `/AdminScreen/credits/credit/${savedCreditId || id}`)}
				saveLabel='Guardar'
			/>
		</EntityList>
	);
}

export default EditCredit;
